import { useState, useMemo } from 'react'

//Styles
import Styles from './pilih-marketing-penjual.module.scss'

//Components
import TextMedium from 'pages/dashboard/e-reporting/forms/components/reuseables/text-medium'
import Order from 'pages/dashboard/e-reporting/forms/components/reuseables/order'
import WrapperAndBox from 'pages/dashboard/e-reporting/forms/components/reuseables/wrapper-and-box/WrapperAndBox'
import SelectWithSearch from 'pages/dashboard/e-reporting/forms/components/reuseables/select-with-search/SelectWithSearch'
import ButtonSelanjutnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-selanjutnya/ButtonSelanjutnya'
import BoxFlex from 'pages/dashboard/e-reporting/forms/components/reuseables/box-flex'
import ButtonSebelumnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-sebelumnya'

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

//hoc
import withFetch from './withFetch'

function PilihMarketingPenjual({ data }) {
  //Context
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { isAprroval, form, isEditing } = useFormState()
  //State
  const [selectedData, setSelectedData] = useState({
    ...form.marketing_penjual.value,
    value: form.marketing_penjual.value.id,
    label: form.marketing_penjual.value.full_name
  })

  const mappedData = useMemo(() => {
    if (!data?.length) return [];
    return data.map(datum => {
      return {
        value: datum.id,
        label: datum.full_name,
        ...datum
      }
    })
  }, [data])

  const onNext = () => {
    handlePrevState()
    formHandler('marketing_penjual', selectedData)
    if (form.is_co_broking.value === 'tidak') {
      formHandler('marketing_pembeli', selectedData)
      setCurrentStep(STEPS.biayaReferralPenjual)
    } else {
      setCurrentStep(STEPS.entryCoListingPenjual)
    }
  }

  const title = useMemo(() => {
    if (form.is_co_broking.value === 'tidak') {
      return 'Siapa marketing?'
    } else {
      return 'Siapa marketing penjual?'
    }
  }, [form.is_co_broking.value])

  return (
    <WrapperAndBox>
      <div className={Styles['title']}>
        <TextMedium required>
          {title}
        </TextMedium>

      </div>
      <div className={Styles['select-wrapper']}>
        <SelectWithSearch selectedData={selectedData} disabled={isAprroval || isEditing} onClick={setSelectedData} options={mappedData} placeholder="Klik di sini atau klik simbol panah" />
        <BoxFlex>
          <>
            <ButtonSebelumnya />
            {selectedData.id !== null ? <ButtonSelanjutnya onClick={onNext} /> : null}
          </>
        </BoxFlex>
      </div>
    </WrapperAndBox>
  )
}

export default withFetch(PilihMarketingPenjual)